/* eslint-disable */
import { configureStore as configureToolkitStore } from '@reduxjs/toolkit';
import reduxPromiseMiddleware from 'redux-promise-middleware';
import { socketMiddleware } from './middlewares';
import rootReducer from './reducers';

const middlewares = [socketMiddleware, reduxPromiseMiddleware];

// use redux dev tools in development
/* eslint-disable no-process-env, no-underscore-dangle */
const useReduxDevTools = Boolean(
	process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
);
/* eslint-enable no-process-env, no-underscore-dangle */

// hydrate initial state, this might be loaded via local storage or caching
export function configureStore(initialState = {}) {
	return configureToolkitStore({
		reducer: rootReducer,
		devTools: useReduxDevTools,
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
		preloadedState: initialState
	});
}

export default configureStore;
